import { Alert } from "@mui/material";
import { ReactElement } from "react";

export const JobError = ({
  errorMessage,
}: {
  errorMessage: string;
}): ReactElement => (
  <Alert severity="error">Import failed: {errorMessage}</Alert>
);
